import createModal from './createModal'
import { _ } from '../gettext'

/**
 * @callback OnConfirm
 * @param {Modal} modal
 */

/**
 * Creates a confirm dialog with 2 buttons.
 *
 * @param {string} title
 * @param {function} onConfirm
 * @return {Modal}
 */
export default function createConfirm (title, onConfirm) {
  const content = `
        <div class="modal-body">${title}</div>
            <div class="modal-footer">
                <a href="#" class="btn btn-primary modal-confirm">${_('Ano')}</a>
                <a href="#" class="btn btn-outline-dark btn-custom modal-close">${_('Zavřít')}</a>
            </div>`

  const modal = createModal(_('Upozornění'), content, true, null)

  const $modalConfirm = modal.$instance.find('.modal-confirm')

  $modalConfirm.on('click', function (e) {
    e.preventDefault()
    onConfirm(modal)
    modal.hide()
  })

  return modal
}
